
import React from 'react';
import ReactDOM  from 'react-dom';
import App from './App';
import Unauthorized from './Unauthorized';
import Messaging from './Messaging';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import './index.css';
import { Router, Route, IndexRoute, hashHistory   } from 'react-router' //, hashHistory 
import thisApp from './reducers/'
import { Provider } from 'react-redux'
import Home from './Pages/Home';
import ProviderPage from './Pages/Provider';
import IdentityPage from './Pages/Identity';
import AccessCodePage from './Pages/AccessCode';
import Messages from './Pages/Messages';
import Message from './Pages/Message';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import SearchResultsPage from './Pages/SearchResults';
import RateApp from './Pages/RateApp';
import SearchPage from './Pages/Search';
import Account from './Pages/Account';
import Logoff from './Pages/Logoff';
import PrivacyPolicyPage from './Pages/PrivacyPolicy';
import PasswordChangePage from './Pages/PasswordChange';
import ResetPassword from './Pages/ResetPassword';
import ConfirmationPage from './Pages/Confirmation';
import ForgotLoginPage from './Pages/ForgotLogin';
import TermsOfUsePage from './Pages/TermsOfUse';
import MyBenefitsPage from './Pages/MyBenefits';
import DocumentsPage from './Pages/Documents';
import TeledocPage from './Pages/Teledoc';
import InsuranceCardPage from './Pages/InsuranceCard';
import MyIncentivesPage from './Pages/MyIncentives';
import CareGuidePage from './Pages/CareGuide';
import Inactive from './Pages/Inactive';
import ConnectPage from './Pages/Connect';
import Logs from './Pages/Logs';
import SupportPage from './Pages/Support';
import OutOfDatePage from './Pages/OutOfDate';
import EndPage from './Pages/End.js';
import ActivityPage from './Pages/Activity.js'
import SsoPage from './Pages/Sso.js';

import injectTapEventPlugin from 'react-tap-event-plugin';
import Static from './Pages/Static';
// import signalRMiddleware from 'middleware/signalRMiddleware'


import NewUser from './Pages/NewUser';
import Login from './Pages/Login';
import thunkMiddleware from 'redux-thunk'
import DeleteAccountPage from './Pages/DeleteAccount';



//require('./styles/trueno.scss');

//let _hub;

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

let createStoreWithMiddleware = applyMiddleware(thunkMiddleware)(createStore);
//applyMiddleware(signalRMiddleware, thunkMiddleware)(createStore);




let reducers = combineReducers({
  thisApp: thisApp
});

let store = createStoreWithMiddleware(
  reducers,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

    // a window variable use for cordova to kow when the scritp has loaded so it can transition.
    window.loadedScript = true;

// window.muiTheme is set in the provider partners js brand file on the server and references via script/src
var whiteLabelColors = window.muiTheme;

window._tokenName = "id_token";
window._tokenTimestamp = "token_timestamp";


const muiTheme = getMuiTheme(whiteLabelColors);

var faScript = document.createElement('script');  
faScript.setAttribute('src','https://kit.fontawesome.com/47438a1d37.js');
faScript.setAttribute('crossorigin','anonymous');
document.head.appendChild(faScript);

//signalRStart(store, () => {
  ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <Router onUpdate={() => window.scrollTo(0, 0)} history={hashHistory}> 
          <Route path="/" component={Login} />
            <Route path="/go/" component={Unauthorized}>
              <Route path="newuser" component={NewUser}/>
              <Route path="identity" component={IdentityPage}/>
              <Route path="accesscode" component={AccessCodePage}/>
              <Route path="resetpassword" component={ResetPassword}/>
              <Route path="forgotlogin" component={ForgotLoginPage}/>
              <Route path="privacy" component={PrivacyPolicyPage} />
              <Route path="terms" component={TermsOfUsePage} />
              <Route path="connect" component={ConnectPage} />
              <Route path="support" component={SupportPage} />
              <Route path="outofdate" component={OutOfDatePage} />
              <Route path="end" component={EndPage} />
            </Route>
            <Route path="/" component={App}>
              <IndexRoute component={Home} />
              <Route path="home" component={Home} />
              <Route path="rate" component={RateApp} />
              <Route path="teledoc" component={TeledocPage} />
              <Route path="sso" component={SsoPage} />
              <Route path="documents" component={DocumentsPage} />
              <Route path="activitytracker" component={ActivityPage} />
              {/* <Route path="messages" component={Messages} />
              <Route path="message/:id/view" component={Message} /> */}
             
              <Route path="provider/:id/view/:sctp/:cost/:docandfacility/:isDx" component={ProviderPage} />
              {/*<Route path="shop/facility/:id/ratings" component={FacilityRatings} />*/}
              <Route path="shop/confirm/:facilityId/:providerId/:cost" component={ConfirmationPage} />
              <Route path="careguide" component={CareGuidePage} />
              <Route path="account" component={Account} />
              <Route path="account/benefits" component={MyBenefitsPage} />
              <Route path="account/incentives/:camm_id" component={MyIncentivesPage} />
              <Route path="account/insurancecard" component={InsuranceCardPage} />
              <Route path="account/password" component={PasswordChangePage} />
              <Route path="account/support" component={SupportPage} />
              <Route path="account/delete" component={DeleteAccountPage} />
              <Route path="logoff" component={Logoff} />
              <Route path="logs" component={Logs} />
              <Route path="inactive" component={Inactive} />
              <Route path="content/:id" component={Static} />
            </Route>
            <Route path="/messages" component={Messaging}>
              <IndexRoute component={Messages} />
            </Route>
            <Route path="/message" component={Messaging}>
              <Route path=":id/view" component={Message} />
            </Route>
            <Route path="/search" component={Messaging}>
              <IndexRoute component={SearchPage} />
              {/* <Route path="search" component={SearchPage} /> */}
              <Route path=":value" component={SearchResultsPage} />
            </Route>
          </Router>
        </MuiThemeProvider>
    </Provider>,
    document.getElementById('root')
  );
//});






// WEBPACK FOOTER //
// ./src/index.js